/** Product-supported Fish language choices; not a claim of equal quality. */
export const FISH_AUDIO_LANGUAGE_OPTIONS = [
  ["en", "English"], ["zh", "Chinese"], ["ja", "Japanese"], ["ko", "Korean"],
  ["es", "Spanish"], ["fr", "French"], ["de", "German"], ["it", "Italian"],
  ["pt", "Portuguese"], ["ar", "Arabic"], ["da", "Danish"], ["el", "Greek"],
  ["fi", "Finnish"], ["he", "Hebrew"], ["hi", "Hindi"], ["ms", "Malay"],
  ["nl", "Dutch"], ["no", "Norwegian"], ["pl", "Polish"], ["ru", "Russian"],
  ["sv", "Swedish"], ["sw", "Swahili"], ["tr", "Turkish"],
  ["id", "Indonesian"], ["th", "Thai"], ["vi", "Vietnamese"], ["ta", "Tamil"],
] as const;
